import { mapDTO } from '@twistezo/ts-dto-mapper'

import { GoogleAdManagerConnection } from '../types'
import { GoogleAdManagerConnectionDTO } from './types'

type From = GoogleAdManagerConnectionDTO
type To = GoogleAdManagerConnection

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(from => ({
    ...from,
    errorMessage: from.errorMessage || undefined,
    updatedAt: new Date(from.updatedAt),
  }))
